import { IApplicationState } from '../../types/redux';
import { selectRegionsByID } from './selectRegionsByID';
import { IRegion } from '../../types/region';

export const selectRegionByID =
  (id: string) =>
  (state: IApplicationState): IRegion => {
    const regionsByID = selectRegionsByID(state);

    return regionsByID[id];
  };
